import React, { useCallback } from 'react';
import { PlaybackManipulationRenderer } from '@bynder-studio/render-web';
import { IconSelect } from '@bynder/icons';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';
import useEditor from 'packages/hooks/useEditor';
import generateTestId from 'packages/helpers/testIdHelpers';
import { TimelineActionsIcon } from 'packages/common/editor/timeline/timeline-actions/TimelineActions.styled';

const testId = generateTestId('timeline_actions_pointer');

export default function PointerAction() {
    const { manipulationRenderer } = useEditor();

    const handleUnselect = useCallback(() => {
        if (manipulationRenderer instanceof PlaybackManipulationRenderer) {
            manipulationRenderer.pausePlayback();
        }

        manipulationRenderer.selectElement(null);
    }, [manipulationRenderer]);

    return (
        <div title={`Select (${parseShortcutForTooltip(['Escape'])})`}>
            <TimelineActionsIcon onClick={handleUnselect} active {...testId}>
                <IconSelect />
            </TimelineActionsIcon>
        </div>
    );
}
